import CheckboxesWidget from "./CheckboxesWidget";

export default CheckboxesWidget;
